import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Checkbox,
  Alert,
  Space,
  Tag,
  Modal,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  InputItem,
  ButtonItem,
  NotificacionPolizas,
  round2Decimals,
  SwitchItem,
  ErrorItem,
  cuentaMask,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";
import ModalComisionesBanco from "../../../../Components/ModalComisionesBanco";
import { UserOutlined, FileTextOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";

const { Option } = Select;
moment.locale("es");

class VerFacturasProveedor extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    facturasProveedor: undefined,
    todasBancos: null,
    objetoBancos: [],
    todasMonedas: null,
    objetoMonedas: null,
    todasFormasDePago: null,
    objetoFormasDePago: null,
    monedaDePago: 'MXN',
    id: this.props.location.state.id,
    notasDeCreditoPendiente: [],
    objetoNotasPendientes: null,
    abonosPendientesProveedores: [],
    objetoAbonosPendientes: null,
    creditosPendientes: [],
    modalAbonosVisible: false,
    abonosSeleccionados: [],
    abonosEnModal: [],
    bancoSeleccionado: null,
    modalComisionVisible: false,
    valoresPendientesPago: null,
    //Complemento Pago con Cuenta Contable (monto extra junto con las facturas)
    pagoConCuentaContableCxP: false,
    cuentaContablePagoCxPId: null,
    objetoCuentasContables: [],
    idsCuentasContables: [],
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: res.data });
          this.setState({
            objetoBancos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.banco}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: this.state.todasBancos && this.state.todasBancos?.length > 0 ? [...this.state.todasBancos, ...res.data] : res.data });
          this.setState({
            objetoBancos: this.state.objetoBancos && this.state.objetoBancos?.length > 0 ? [...this.state.objetoBancos, ...res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            })] : res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "formasdepago/selectFormasDePago",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasFormasDePago: res.data });
          this.setState({
            objetoFormasDePago: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_FormaPago + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cuentasporpagar/selectFacturasPProveedor",
        {
          empresaId: this.props.empresaId,
          proveedorId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del proveedor");
        } else {
          let nuevasFacturas = (res.data.facturas || []).map((value) => {
            return {
              ...value,
              proyectoNombre: value.proyecto.nombre,
              tipoDeCambioCompra: value.tipoDeCambio,
              saldoPendiente: round2Decimals(value.totalPagar - value.totalPagado),
            };
          });
          let nuevosCreditos = (res.data.creditosPendientes || []).map((value) => {
            return {
              ...value,
              proyectoNombre: value.proyecto?.nombre || '',
              tipoDeCambioCredito: value.tipoCambio,
              saldoPendiente: round2Decimals(value.saldo),
            };
          });
          this.setState({
            facturasProveedor: nuevasFacturas, notasDeCreditoPendiente: res.data.notasDeCreditoPendiente,
            creditosPendientes: nuevosCreditos,
            objetoNotasPendiente: res.data.notasDeCreditoPendiente.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaFactura).format('L') + " - " + dineroDisabledMask(value.totalPagar - value.totalPagado) + ' - ' + value.moneda.abreviacion +
                  (value.descripcion ? " | " + value.descripcion : "")}
                </Option>
              );
            }),
            abonosPendientesProveedores: res.data.abonosPendientesProveedores,
            objetoAbonosPendientes: res.data.abonosPendientesProveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaPago).format('L') + " - " + dineroDisabledMask(value.monto - (value.totalPagadoAbono || 0)) + ' - ' + value.moneda?.abreviacion}
                </Option>
              );
            }),
            pagoConCuentaContableCxP: res.data.pagoConCuentaContableCxP === true,
            cuentaContablePagoCxPId: res.data.cuentaContablePagoCxPId || null,
          });
          this.formRef.current.setFieldsValue({ facturas: nuevasFacturas, creditos: nuevosCreditos });
        }
      });
    //Las cuentas contables solo hacen falta si la empresa paga montos extra a cuenta contable
    if (this.state.pagoConCuentaContableCxP) {
      await this.consultarCuentasContables()
    }
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }

  onChangeMoneda(value, fecha, setGlobal) {
    if (value && value !== "60c7e4396465ad440c41c15a") {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
            fecha: fecha || undefined,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success(
                "Se ha obtenido el tipo de cambio" +
                  (res.data.monedaString ? " " + res.data.monedaString : "") +
                  (res.data.dia ? " del día " + res.data.dia : "")
              );
            }
            const setVals = { tipoDeCambioPago: res.data.tipoDeCambio };
            if (setGlobal) {
              setVals.tipoDeCambioGlobal = res.data.tipoDeCambio;
            }
            this.formRef.current.setFieldsValue(setVals);
          }
        });
    } else {
      this.formRef.current.setFieldsValue({ tipoDeCambioPago: 1 });
    }
  }

  aplicarTipoCambioFacturas = () => {
    const tipoDeCambio = this.formRef.current.getFieldValue('tipoDeCambioGlobal')
    if (!tipoDeCambio || tipoDeCambio <= 0) {
      return message.info('Capture un tipo de cambio válido')
    }
    const facturas = this.formRef.current.getFieldValue('facturas') || []
    const nuevasFacturas = facturas.map((f, idx) => {
      const facturaState = this.state.facturasProveedor?.[idx]
      if (facturaState && facturaState.monedaId !== '60c7e4396465ad440c41c15a') {
        return { ...f, tipoDeCambioCompra: tipoDeCambio }
      }
      return f
    })
    const creditos = this.formRef.current.getFieldValue('creditos') || []
    const nuevosCreditos = creditos.map((c, idx) => {
      const creditoState = this.state.creditosPendientes?.[idx]
      if (creditoState && creditoState.monedaId !== '60c7e4396465ad440c41c15a') {
        return { ...c, tipoDeCambioCredito: tipoDeCambio }
      }
      return c
    })
    this.formRef.current.setFieldsValue({ facturas: nuevasFacturas, creditos: nuevosCreditos })
    this.forceUpdate()
    message.success('Tipo de cambio aplicado a items en moneda extranjera')
  };

  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    const monedaIdPago = values.monedaId
    const tipoDeCambioPago = values.tipoDeCambioPago || 1
    const facturas = values.facturas || []
    const creditos = values.creditos || []

    // Validar TC y saldo por factura
    for (let idx = 0; idx < facturas.length; idx++) {
      const f = facturas[idx]
      const fs = this.state.facturasProveedor?.[idx]
      if (!fs) continue
      const cantidadPagar = f.cantidadPagar || 0
      if (cantidadPagar <= 0) continue
      if (cantidadPagar < 0) {
        return message.error(`Factura ${fs.codigoFactura}: la cantidad a pagar no puede ser negativa`)
      }
      const tc = f.tipoDeCambioCompra || 1
      if (fs.monedaId !== '60c7e4396465ad440c41c15a' && (!tc || tc <= 0)) {
        return message.error(`Factura ${fs.codigoFactura}: el tipo de cambio debe ser mayor a 0`)
      }
      const equivalencia = tipoDeCambioPago / tc
      const maxPagar = round2Decimals(fs.saldoPendiente / equivalencia)
      if (round2Decimals(cantidadPagar) > maxPagar + 0.01) {
        return message.error(`Factura ${fs.codigoFactura}: la cantidad a pagar (${dineroDisabledMask(cantidadPagar)}) excede el saldo pendiente (${dineroDisabledMask(maxPagar)})`)
      }
    }

    // Validar TC y saldo por crédito
    for (let idx = 0; idx < creditos.length; idx++) {
      const c = creditos[idx]
      const cs = this.state.creditosPendientes?.[idx]
      if (!cs) continue
      const cantidadPagar = c.cantidadPagar || 0
      if (cantidadPagar <= 0) continue
      if (cantidadPagar < 0) {
        return message.error(`Crédito ${cs.nombre}: la cantidad a pagar no puede ser negativa`)
      }
      const tc = c.tipoDeCambioCredito || 1
      if (cs.monedaId !== '60c7e4396465ad440c41c15a' && (!tc || tc <= 0)) {
        return message.error(`Crédito ${cs.nombre}: el tipo de cambio debe ser mayor a 0`)
      }
      const equivalencia = tipoDeCambioPago / tc
      const maxPagar = round2Decimals(cs.saldoPendiente / equivalencia)
      if (round2Decimals(cantidadPagar) > maxPagar + 0.01) {
        return message.error(`Crédito ${cs.nombre}: la cantidad a pagar (${dineroDisabledMask(cantidadPagar)}) excede el saldo pendiente (${dineroDisabledMask(maxPagar)})`)
      }
    }

    // Validar que TC coincida cuando moneda factura = moneda pago
    const facturasConTcDistinto = facturas.filter((f, idx) => {
      const fs = this.state.facturasProveedor?.[idx]
      if (!fs || !f.cantidadPagar || f.cantidadPagar <= 0) return false
      if (fs.monedaId !== monedaIdPago) return false
      return round2Decimals(f.tipoDeCambioCompra) !== round2Decimals(tipoDeCambioPago)
    })
    if (facturasConTcDistinto.length > 0) {
      return message.error('Cuando la moneda de la factura y del pago son iguales, el tipo de cambio debe ser el mismo en todas las facturas a pagar')
    }

    // Validar que TC coincida cuando moneda crédito = moneda pago
    const creditosConTcDistinto = creditos.filter((c, idx) => {
      const cs = this.state.creditosPendientes?.[idx]
      if (!cs || !c.cantidadPagar || c.cantidadPagar <= 0) return false
      if (cs.monedaId !== monedaIdPago) return false
      return round2Decimals(c.tipoDeCambioCredito) !== round2Decimals(tipoDeCambioPago)
    })
    if (creditosConTcDistinto.length > 0) {
      return message.error('Cuando la moneda del crédito y del pago son iguales, el tipo de cambio debe ser el mismo en todos los créditos a pagar')
    }

    let cantidadPagarTotal = 0
    facturas.forEach((f) => { cantidadPagarTotal += f.cantidadPagar || 0 })
    creditos.forEach((c) => { cantidadPagarTotal += c.cantidadPagar || 0 })

    if (cantidadPagarTotal === 0)
      return message.info('Se necesitan cantidades para poder hacer esta operación')

    // Validar nota de crédito
    if (values.pagarConNotas) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((n) => n._id.toString() === values.notaId?.toString())
      if (!notaCredito) return message.error('No se encontró la nota de crédito seleccionada')
      const saldoNota = round2Decimals(notaCredito.totalPagar - notaCredito.totalPagado)
      if (round2Decimals(cantidadPagarTotal) > saldoNota + 0.01) {
        return message.error(`No se puede pagar más del saldo pendiente de la nota de crédito (${dineroDisabledMask(saldoNota)})`)
      }
    }

    // Validar abono(s)
    if (values.pagarConAbono) {
      if (this.state.abonosSeleccionados.length > 0) {
        const totalDisponible = this.state.abonosSeleccionados.reduce((acc, id) => {
          const abono = this.state.abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
          return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
        }, 0)
        if (round2Decimals(cantidadPagarTotal) > round2Decimals(totalDisponible) + 0.01) {
          return message.error(`No se puede pagar más del saldo disponible de los abonos seleccionados (${dineroDisabledMask(totalDisponible)})`)
        }
      } else {
        const abono = this.state.abonosPendientesProveedores.find((a) => a._id.toString() === values.abonoId?.toString())
        if (!abono) return message.error('No se encontró el abono seleccionado')
        const saldoAbono = round2Decimals(abono.monto - (abono.totalPagadoAbono || 0))
        if (round2Decimals(cantidadPagarTotal) > saldoAbono + 0.01) {
          return message.error(`No se puede pagar más del saldo pendiente del abono (${dineroDisabledMask(saldoAbono)})`)
        }
      }
    }

    const creditosPayload = creditos
      .map((c, idx) => ({
        _id: this.state.creditosPendientes[idx]?._id,
        cantidadPagar: c.cantidadPagar || 0,
        tipoDeCambioCredito: c.tipoDeCambioCredito,
      }))
      .filter((c) => c._id && c.cantidadPagar > 0);

    if (this.state.pagoConCuentaContableCxP && values.pagoConCuentaContable) {
      if (!(Number(values.montoCuentaContable) > 0)) {
        return message.error('Capture el monto extra a cuenta contable')
      }
      if (!values.cuentaContablePagoId) {
        return message.error('Seleccione la cuenta contable del monto extra')
      }
      if (!values.bancoId) {
        return message.error('Seleccione el banco del pago')
      }
      if (!facturas.some((f) => (f.cantidadPagar || 0) > 0)) {
        return message.error('El monto extra a cuenta contable se paga junto con el pago de al menos una factura')
      }
    }

    const valoresEnvio = { ...values, creditos: creditosPayload };

    if (this.state.bancoSeleccionado?.paquetesComision?.length > 0) {
      this.setState({ modalComisionVisible: true, valoresPendientesPago: valoresEnvio })
      return
    }
    this.enviarPago(valoresEnvio, [])
  }

  async consultarCuentasContables() {
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ objetoCuentasContables: [], idsCuentasContables: [] })
        } else {
          this.setState({
            idsCuentasContables: res.data.map((value) => value._id.toString()),
            objetoCuentasContables: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      })
      .catch(() => {
        message.error("No se pudieron consultar las cuentas contables");
      });
  }

  //Cuenta predefinida en Complementos, solo si esta en la lista de cuentas finales
  cuentaContablePagoDefault() {
    const cuentaId = this.state.cuentaContablePagoCxPId
    if (cuentaId && this.state.idsCuentasContables.includes(cuentaId.toString())) {
      return cuentaId
    }
    return undefined
  }

  //El switch no viaja al backend; sin el switch encendido tampoco viajan el monto extra ni la cuenta
  limpiarValoresCuentaContable(values) {
    const valores = { ...values }
    const conMontoExtra = !!(this.state.pagoConCuentaContableCxP && valores.pagoConCuentaContable)
    delete valores.pagoConCuentaContable
    if (!conMontoExtra) {
      delete valores.montoCuentaContable
      delete valores.cuentaContablePagoId
    }
    return valores
  }

  enviarPago(values, paquetesComisionIds) {
    this.setState({ loading: true });
    axios
      .post(
        "cuentasporpagar/pagarFacturasProveedor",
        {
          ...this.limpiarValoresCuentaContable(values),
          empresaId: this.props.empresaId,
          proveedorId: this.state.id,
          abonosIds: this.state.abonosSeleccionados.length > 0 ? this.state.abonosSeleccionados : undefined,
          paquetesComisionIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha recibido un pago");
          NotificacionPolizas(res.data.polizasId)
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message);
        } else {
          message.error("Hubo un error y no se recibio el pago");
        }
      });
  }

  renderModalComision() {
    const { modalComisionVisible, valoresPendientesPago, bancoSeleccionado } = this.state
    return (
      <ModalComisionesBanco
        visible={modalComisionVisible}
        banco={bancoSeleccionado}
        moneda={(this.state.todasMonedas || []).find(valueMoneda => valueMoneda._id.toString() === bancoSeleccionado?.monedaId?.toString())?.abreviacion}
        onCancel={() => this.setState({ modalComisionVisible: false })}
        onOk={(paquetesComisionIds) => {
          const values = valoresPendientesPago
          this.setState({ modalComisionVisible: false, valoresPendientesPago: null })
          this.enviarPago(values, paquetesComisionIds)
        }}
      />
    )
  }

  atras() {
    this.props.history.goBack();
  }
  onChangeBanco(bancoId) {
    if (bancoId) {
      const banco = this.state.todasBancos.find((valueTodosBancos) => valueTodosBancos._id.toString() === bancoId.toString())
      if (banco.caja) {
        message.info('Se tendra que reponer el saldo en la caja chica')
      }
      this.setState({ bancoSeleccionado: banco || null })
    } else {
      this.setState({ bancoSeleccionado: null })
    }
  }

  onChangeNotaDeCredito(notaId) {
    if (notaId) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())
      this.formRef.current.setFieldsValue({ monedaId: notaCredito.monedaId, tipoDeCambioPago: notaCredito.tipoDeCambio })
    }
  }

  onChangeCheque(value) {
    if (value.target.checked) {
      this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d59' })
    } else {
      this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d5a' })
    }
  }

  onChangeAbono(abonoId) {
    if (abonoId) {
      const abono = this.state.abonosPendientesProveedores.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
      this.formRef.current.setFieldsValue({ monedaId: abono.monedaId, tipoDeCambioPago: abono.tipoDeCambioPago, fechaPago: abono.fechaPago ? moment(abono.fechaPago) : null })
    }
  }

  getFacturasColumns() {
    return [
      { title: "Codigo", width: "10%" },
      { title: "Proyecto", width: "15%" },
      { title: "Fecha Vencimiento", width: "10%" },
      { title: "Moneda", width: "10%" },
      { title: "T. C.", width: "10%" },
      { title: "Total a Pagar", width: "10%" },
      { title: "Total Pagado", width: "10%" },
      { title: "Saldo Pendiente", width: "10%" },
      { title: `Cantidad a Pagar ${this.state.monedaDePago}`, width: "15%" },
    ];
  }

  getCreditosColumns() {
    return [
      { title: "Nombre", width: "15%" },
      { title: "Proyecto", width: "15%" },
      { title: "Fecha Vencimiento", width: "10%" },
      { title: "Moneda", width: "10%" },
      { title: "T. C.", width: "10%" },
      { title: "Total Crédito", width: "10%" },
      { title: "Total Pagado", width: "10%" },
      { title: "Saldo Pendiente", width: "10%" },
      { title: `Cantidad a Pagar ${this.state.monedaDePago}`, width: "10%" },
    ];
  }

  renderTcGlobalHeader() {
  return (
    <FormItem noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const monedaId = getFieldValue('monedaId')
        if (!monedaId || monedaId === '60c7e4396465ad440c41c15a') return null
        return (
          <Row gutter={[8, 8]} style={{ marginBottom: 8 }}>
            <Col xs={0} sm={0} md={2} lg={3} xl={4} />
            <Col xs={24} sm={24} md={22} lg={21} xl={20}>
              <div
                style={{
                  padding: '6px 8px',
                  border: '2px dashed #00BFD6',
                  marginRight: 20,
                  borderRadius: 6,
                }}
              >
                <Row gutter={4} align="middle" wrap={false}>
                  <Col flex="1 1 auto" style={{ minWidth: 0 }}>
                    <FormItem noStyle name="tipoDeCambioGlobal" type="number">
                      <InputNumberItem
                        size='small'
                        dinero
                        placeholder="T. C. Facturas"
                        style={{ width: '100%' }}
                        onPressEnter={this.aplicarTipoCambioFacturas}
                      />
                    </FormItem>
                  </Col>
                  <Col flex="none">
                    <ButtonItem
                      size='small'
                      type='primary'
                      onClick={this.aplicarTipoCambioFacturas}
                    >
                      Aplicar
                    </ButtonItem>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        )
      }}
    </FormItem>
  );
}

  renderFacturaRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <tr key={key}>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, fontWeight: 600, color: '#1a3a4a' }}>
            {
              this.state.facturasProveedor[arrayKey]
                .codigoFactura
            }
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {
              this.state.facturasProveedor[arrayKey]
                .proyectoNombre
            }
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {moment(
              this.state.facturasProveedor[arrayKey]
                .fechaPago
            )
              .locale("es")
              .format("L")}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {
              this.state.facturasProveedor[arrayKey]
                .moneda.abreviacion
            }
          </p>
        </td>
        <td className="td-border" style={{ textAlign: 'center' }}>
          <FormItem
            {...restField}
            name={[name, "tipoDeCambioCompra"]}
            fieldKey={[arrayKey, "tipoDeCambioCompra"]}
            noStyle
            numberCero
            initialValue={1}
            type='number'
          >
            <InputNumberItem
              sinBorde
              disabled={this.state.facturasProveedor[arrayKey].monedaId === '60c7e4396465ad440c41c15a'}
              style={{ width: '100%', textAlign: 'center' }}
              placeholder={'Factura: ' + this.state.facturasProveedor[arrayKey].tipoDeCambio}
              dinero
              size='small'
            />
          </FormItem>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(
              this.state.facturasProveedor[arrayKey]
                .totalPagar
            )}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(
              this.state.facturasProveedor[arrayKey]
                .totalPagado
            )}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#ee3b3e', fontWeight: 600 }}>
            {dineroDisabledMask(
              this.state.facturasProveedor[arrayKey]
                .saldoPendiente
            )}
          </p>
        </td>
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {

              const facturas = getFieldValue('facturas')

              const tipoDeCambioCompra = facturas[arrayKey].tipoDeCambioCompra
              const tipoDeCambioPago = getFieldValue('tipoDeCambioPago')

              const equivalencia = tipoDeCambioPago / tipoDeCambioCompra

              const saldoPendiente = round2Decimals(
                (this.state.facturasProveedor[arrayKey].saldoPendiente) / equivalencia
              );

              const cantidadPagar = facturas?.[arrayKey]?.cantidadPagar || 0;
              const esTotal = cantidadPagar > 0 && cantidadPagar === saldoPendiente;

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}>
                  <ButtonItem
                    size="small"
                    olivo
                    style={{ padding: '12px 12px' }}
                    type={esTotal ? 'primary' : 'default'}
                    title="Asignar total"
                    onClick={() => {
                      const facturasVal = this.formRef.current.getFieldValue("facturas");
                      if (!esTotal) {
                        facturasVal[arrayKey].cantidadPagar = saldoPendiente;
                      } else {
                        facturasVal[arrayKey].cantidadPagar = null;
                      }
                      this.formRef.current.setFieldsValue({ facturas: facturasVal });
                    }}
                  >
                    Total
                  </ButtonItem>
                  <div style={{ flex: 1 }} className={esTotal ? 'cantidad-pagar-total' : ''}>
                    <FormItem
                      {...restField}
                      name={[name, "cantidadPagar"]}
                      fieldKey={[arrayKey, "cantidadPagar"]}
                      noStyle
                      numberCero
                      type="number"
                      max={
                        saldoPendiente
                      }
                    >
                      <InputNumberItem
                        style={{ width: "100%" }}
                        placeholder={
                          "Max: " + saldoPendiente
                        }
                        dinero
                        size="small"
                      />
                    </FormItem>
                  </div>
                </div>
              )
            }}
          </FormItem>
        </td>
      </tr>
    );
  }

  renderCreditoRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <tr key={key}>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, fontWeight: 600, color: '#1a3a4a' }}>
            {this.state.creditosPendientes[arrayKey].nombre}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {this.state.creditosPendientes[arrayKey].proyectoNombre}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {this.state.creditosPendientes[arrayKey].fechaVencimiento
              ? moment(this.state.creditosPendientes[arrayKey].fechaVencimiento).locale("es").format("L")
              : ''}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#555' }}>
            {this.state.creditosPendientes[arrayKey].moneda?.abreviacion}
          </p>
        </td>
        <td className="td-border" style={{ textAlign: 'center' }}>
          <FormItem
            {...restField}
            name={[name, "tipoDeCambioCredito"]}
            fieldKey={[arrayKey, "tipoDeCambioCredito"]}
            noStyle
            numberCero
            initialValue={1}
            type='number'
          >
            <InputNumberItem
              sinBorde
              disabled={this.state.creditosPendientes[arrayKey].monedaId === '60c7e4396465ad440c41c15a'}
              style={{ width: '100%', textAlign: 'center' }}
              placeholder={'Crédito: ' + this.state.creditosPendientes[arrayKey].tipoCambio}
              dinero
              size='small'
            />
          </FormItem>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(this.state.creditosPendientes[arrayKey].totalCredito)}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0 }}>
            {dineroDisabledMask(this.state.creditosPendientes[arrayKey].totalPagado)}
          </p>
        </td>
        <td className="td-border-center">
          <p style={{ marginBottom: 0, color: '#FF6A0D', fontWeight: 600 }}>
            {dineroDisabledMask(this.state.creditosPendientes[arrayKey].saldoPendiente)}
          </p>
        </td>

        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {

              const creditos = getFieldValue('creditos')

              const tipoDeCambioCredito = creditos[arrayKey].tipoDeCambioCredito
              const tipoDeCambioPago = getFieldValue('tipoDeCambioPago')

              const equivalencia = tipoDeCambioPago / tipoDeCambioCredito

              const saldoPendiente = round2Decimals(
                (this.state.creditosPendientes[arrayKey].saldoPendiente) / equivalencia
              );

              const cantidadPagar = creditos?.[arrayKey]?.cantidadPagar || 0;
              const esTotal = cantidadPagar > 0 && cantidadPagar === saldoPendiente;

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}>
                  <ButtonItem
                    size="small"
                    type={esTotal ? 'primary' : 'default'}
                    title="Asignar total"
                    onClick={() => {
                      const creditosVal = this.formRef.current.getFieldValue("creditos");
                      if (!esTotal) {
                        creditosVal[arrayKey].cantidadPagar = saldoPendiente;
                      } else {
                        creditosVal[arrayKey].cantidadPagar = null;
                      }
                      this.formRef.current.setFieldsValue({ creditos: creditosVal });
                    }}
                  >
                    T
                  </ButtonItem>
                  <div style={{ flex: 1 }} className={esTotal ? 'cantidad-pagar-total' : ''}>
                    <FormItem
                      {...restField}
                      name={[name, "cantidadPagar"]}
                      fieldKey={[arrayKey, "cantidadPagar"]}
                      noStyle
                      numberCero
                      type="number"
                      max={saldoPendiente}
                    >
                      <InputNumberItem
                        style={{ width: "100%" }}
                        placeholder={"Max: " + saldoPendiente}
                        dinero
                        size="small"
                      />
                    </FormItem>
                  </div>
                </div>
              )
            }}
          </FormItem>
        </td>
      </tr>
    );
  }

  renderModalAbonos() {
    const { abonosEnModal, abonosPendientesProveedores } = this.state
    const totalSeleccionado = abonosEnModal.reduce((acc, id) => {
      const abono = abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
      return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
    }, 0)

    const confirmarAbonos = () => {
      this.setState({ abonosSeleccionados: [...abonosEnModal], modalAbonosVisible: false })
      if (abonosEnModal.length === 0) {
        this.formRef.current?.setFieldsValue({ abonoId: undefined })
      }
    }

    const footer = (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 13, color: '#555' }}>
          Total disponible: <strong>{dineroDisabledMask(totalSeleccionado)}</strong>
        </span>
        <div>
          <ButtonItem style={{ marginRight: 8 }} onClick={() => this.setState({ modalAbonosVisible: false })}>
            Cancelar
          </ButtonItem>
          <ButtonItem type="primary" onClick={confirmarAbonos}>
            Confirmar ({abonosEnModal.length})
          </ButtonItem>
        </div>
      </div>
    )

    return (
      <Modal
        title="Seleccionar abonos"
        visible={this.state.modalAbonosVisible}
        onCancel={() => this.setState({ modalAbonosVisible: false })}
        footer={footer}
        width={520}
        destroyOnClose={false}
      >
        <div style={{ maxHeight: 360, overflowY: 'auto', margin: '0 -24px' }}>
          {abonosPendientesProveedores.length === 0 && (
            <div style={{ padding: '16px 24px', color: '#999' }}>No hay abonos pendientes</div>
          )}
          {abonosPendientesProveedores.map((abono) => {
            const disponible = round2Decimals(abono.monto - (abono.totalPagadoAbono || 0))
            const checked = abonosEnModal.includes(abono._id.toString())
            return (
              <div
                key={abono._id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px 24px',
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer',
                  background: checked ? '#f0fcfe' : undefined,
                }}
                onClick={() => {
                  const id = abono._id.toString()
                  const next = checked
                    ? abonosEnModal.filter(x => x !== id)
                    : [...abonosEnModal, id]
                  this.setState({ abonosEnModal: next })
                }}
              >
                <Checkbox checked={checked} style={{ marginRight: 12 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 500, fontSize: 13 }}>{abono.concepto || 'Abono'}</div>
                  <div style={{ fontSize: 12, color: '#888' }}>{abono.serie || ''}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 600, color: '#00BFD6' }}>{dineroDisabledMask(disponible)}</div>
                  <div style={{ fontSize: 11, color: '#aaa' }}>disponible</div>
                </div>
              </div>
            )
          })}
        </div>
      </Modal>
    )
  }

  render() {
    return (
      <>
        <style>{`
          .cantidad-pagar-total .ant-input-number-input {
            font-weight: 700 !important;       
          }
        `}</style>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={"Cuentas por pagar "}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div
          style={{
            background: "linear-gradient(135deg, #f0fcfe 0%, #ffffff 100%)",
            padding: "16px 20px",
            marginBottom: 12,
            border: "1px solid #b5edf3",
            borderLeft: "5px solid #00BFD6",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            gap: 12,
            boxShadow: "0 2px 8px rgba(0, 191, 214, 0.08)",
          }}
        >
          <FileTextOutlined style={{ color: "#00BFD6", fontSize: 18 }} />
          <span style={{ color: "#262626", fontWeight: "bold", fontSize: 16 }}>
            {this.props.location.state.nombre || "Cargando..."}
          </span>
        </div>
        {this.state.notasDeCreditoPendiente.length > 0 &&
          <Alert onClick={() => this.formRef.current.setFieldsValue({ pagarConNotas: true, pagoConCuentaContable: false })} style={{ marginBottom: 10 }} description='Cambie a notas de credito para pagar con una de ellas' showIcon message="Este proveedor contiene notas de credito pendientes" type="warning" />
        }
        {this.state.abonosPendientesProveedores.length > 0 &&
          <Alert onClick={() => this.formRef.current.setFieldsValue({ pagarConAbono: true, pagarConNotas: false, abonoId: undefined, pagoConCuentaContable: false })} style={{ marginBottom: 10 }} description='Cambie a abonos para cobrar con uno de ellos' showIcon message="Este proveedor contiene abonos pendientes" type="warning" />
        }
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="facturasPendientesProveedor"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row gutter={[16, 16]}>
                <DynamicCardForm
                  title= {<span>MONEDA</span>}
                  span={8}
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={8}
                >
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      const pagarConNotas = getFieldValue('pagarConNotas')
                      const pagarConAbono = getFieldValue('pagarConAbono')
                      return (
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda Pago"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 12 }}
                          initialValue={'60c7e4396465ad440c41c15a'}
                        >
                          <SelectItem
                            placeholder="Moneda"
                            disabled={pagarConNotas || pagarConAbono}
                            onChange={(value) => {
                              if (!value) return

                              this.onChangeMoneda(value)

                              const moneda = this.state?.todasMonedas?.find(
                                (m) => m._id.toString() === value.toString()
                              )

                              if (moneda) {
                                this.setState({ monedaDePago: moneda.abreviacion })
                              }
                            }}
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>

                        </FormItem>
                      )
                    }}
                  </FormItem>
                  <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.pagarConNotas !== curr.pagarConNotas}>
                    {({ getFieldValue }) => {

                      const monedaId = getFieldValue('monedaId')


                      const pagarConNotas = getFieldValue('pagarConNotas')

                      const pagarConAbono = getFieldValue('pagarConAbono')

                      const moneda = this.state.todasMonedas ? this.state.todasMonedas.find((valueTodasMonedas) => valueTodasMonedas._id.toString() === monedaId.toString()) : null

                      return (
                        <FormItem
                          required
                          number
                          margin
                          hidden={monedaId === '60c7e4396465ad440c41c15a'}
                          label={`T. C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                          name="tipoDeCambioPago"
                          type="number"
                          initialValue={1}
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 12 }}
                        >
                          <InputNumberItem
                            disabled={monedaId === '60c7e4396465ad440c41c15a' || pagarConNotas || pagarConAbono}
                            dinero
                            placeholder={`T. C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                          />
                        </FormItem>
                      )
                    }}
                  </FormItem>
                </DynamicCardForm>
                <DynamicCardForm
                  title={
                    <Space size={8}>
                      <UserOutlined style={{ color: '#FF6A0D' }} />
                      <span>PROVEEDOR&nbsp;&nbsp;:&nbsp;&nbsp;{this.props.location.state.nombre}</span>
                      {this.props.location.state.rfc && (
                        <span> - RFC&nbsp;&nbsp;:&nbsp;&nbsp;{this.props.location.state.rfc}</span>
                      )}
                    </Space>
                  }
                  span={16}
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={16}
                >
                  <Row>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <FormItem
                        label="Fecha"
                        name="fechaPago"
                        required
                        margin
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <DatePickerItem
                          placeholder="Fecha de Pago"
                          allowClear={false}
                          onChange={(date) => {
                            const monedaId = this.formRef.current.getFieldValue('monedaId')
                            if (monedaId && monedaId !== '60c7e4396465ad440c41c15a') {
                              this.onChangeMoneda(monedaId, date, true)
                            }
                          }}
                        />
                      </FormItem>
                      <FormItem
                        label="Proyecto"
                        name="proyectoId"
                        required
                        margin
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 16 }}
                      >
                        <SelectProyectosItem
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          width="100%"
                          placeholder="Proyecto"
                        />
                      </FormItem>
                      {this.state.notasDeCreditoPendiente.length > 0 &&
                        <FormItem
                          name="pagarConNotas"
                          label="Pagar C/Notas"
                          tooltip={{ title: "Pagar la factura con notas de credito" }}
                          margin
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 16 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            placeholder="Pagar Con Notas"
                            onChange={(checked) => {
                              if (checked && this.state.pagoConCuentaContableCxP) {
                                this.formRef.current.setFieldsValue({ pagoConCuentaContable: false })
                              }
                            }}
                          />
                        </FormItem>
                      }
                      {this.state.abonosPendientesProveedores?.length > 0 &&
                        <FormItem
                          name="pagarConAbono"
                          label="Cobrar C/Abono"
                          tooltip={{ title: "Cobrar la venta con un abono" }}
                          margin
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 16 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            onChange={(checked) => {
                              if (checked) {
                                this.formRef.current.setFieldsValue({ pagarConNotas: false, notaId: null, pagoConCuentaContable: false })
                              } else {
                                this.setState({ abonosSeleccionados: [], abonosEnModal: [] })
                                this.formRef.current.setFieldsValue({ abonoId: null })
                              }
                            }}
                            placeholder="Cobrar Con Abono"
                          />
                        </FormItem>
                      }
                      {this.state.pagoConCuentaContableCxP &&
                        <FormItem
                          name="pagoConCuentaContable"
                          label="Extra a cuenta"
                          tooltip={{ title: "Pagar, junto con las facturas y del mismo banco, un monto extra que se carga a una cuenta contable" }}
                          margin
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 16 }}
                          pattern
                          valuePropName="checked"
                        >
                          <SwitchItem
                            onChange={(checked) => {
                              if (checked) {
                                this.setState({ abonosSeleccionados: [], abonosEnModal: [] })
                                this.formRef.current.setFieldsValue({
                                  pagarConNotas: false,
                                  notaId: null,
                                  pagarConAbono: false,
                                  abonoId: null,
                                  cuentaContablePagoId: this.cuentaContablePagoDefault(),
                                })
                              } else {
                                this.formRef.current.setFieldsValue({ montoCuentaContable: undefined })
                              }
                            }}
                            placeholder="Pagar extra a cuenta contable"
                          />
                        </FormItem>
                      }
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const pagarConNotas = getFieldValue('pagarConNotas')
                          const pagarConAbono = getFieldValue('pagarConAbono')

                          if (pagarConNotas) {
                            return (
                              <FormItem
                                label="Nota"
                                name="notaId"
                                margin
                                required
                                labelCol={{ span: 7 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <SelectItem placeholder="Nota" dropdownMatchSelectWidth={false} onChange={this.onChangeNotaDeCredito.bind(this)} >
                                  {this.state.objetoNotasPendiente}
                                </SelectItem>
                              </FormItem>
                            )
                          } else if (pagarConAbono) {
                            const abonosSeleccionados = this.state.abonosSeleccionados
                            if (abonosSeleccionados.length > 0) {
                              const totalDisponible = abonosSeleccionados.reduce((acc, id) => {
                                const abono = this.state.abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
                                return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
                              }, 0)
                              return (
                                <FormItem
                                  label=" "
                                  colon={false}
                                  labelCol={{ span: 7 }}
                                  wrapperCol={{ span: 16 }}
                                  style={{ marginBottom: 8 }}
                                >
                                  <Row align="middle" gutter={[6, 0]}>
                                    <Col flex="auto">
                                      <div style={{ padding: '6px 10px', background: '#f0fcfe', border: '1px solid #b5edf3', borderRadius: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 600, fontSize: 13 }}>{abonosSeleccionados.length} abono(s)</span>
                                        <span style={{ color: '#555', fontSize: 12 }}>Disp: {dineroDisabledMask(totalDisponible)}</span>
                                      </div>
                                    </Col>
                                    <Col flex="none">
                                      <ButtonItem size="small" onClick={() => this.setState({ modalAbonosVisible: true, abonosEnModal: [...abonosSeleccionados] })}>
                                        Cambiar
                                      </ButtonItem>
                                    </Col>
                                    <Col flex="none">
                                      <ButtonItem size="small" danger onClick={() => this.setState({ abonosSeleccionados: [], abonosEnModal: [] })}>
                                        Quitar
                                      </ButtonItem>
                                    </Col>
                                  </Row>
                                </FormItem>
                              )
                            }
                            return (
                              <Row align="middle" gutter={[6, 0]}>
                                <Col span={19}>
                                  <FormItem
                                    label="Abono"
                                    name="abonoId"
                                    margin
                                    required
                                    labelCol={{ span: 9 }}
                                    wrapperCol={{ span: 15 }}
                                  >
                                    <SelectItem placeholder="Abono" onChange={this.onChangeAbono.bind(this)}>
                                      {this.state.objetoAbonosPendientes}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={5} style={{ textAlign: 'center', paddingBottom: 8 }}>
                                  <ButtonItem
                                    size="small"
                                    onClick={() => this.setState({ modalAbonosVisible: true, abonosEnModal: [] })}
                                  >
                                    Varios
                                  </ButtonItem>
                                </Col>
                              </Row>
                            )
                          } else {
                            return (
                              <>
                                <FormItem
                                  label="Banco"
                                  name="bancoId"
                                  margin
                                  labelCol={{ span: 7 }}
                                  wrapperCol={{ span: 16 }}
                                  required
                                >
                                  <SelectItem onChange={this.onChangeBanco.bind(this)} placeholder="Banco">
                                    {this.state.objetoBancos}
                                  </SelectItem>
                                </FormItem>
                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    const cheque = getFieldValue('cheque')
                                    return (
                                      <FormItem
                                        name="formaDePagoId"
                                        label="F Pago"
                                        initialValue="6125149afe07662acc100d5a"
                                        margin
                                        required
                                        labelCol={{ span: 7 }}
                                        wrapperCol={{ span: 16 }}
                                      >
                                        <SelectItem disabled={cheque} placeholder="Forma de Pago">
                                          {this.state.objetoFormasDePago}
                                        </SelectItem>
                                      </FormItem>
                                    )
                                  }}
                                </FormItem>
                                {this.state.pagoConCuentaContableCxP && getFieldValue('pagoConCuentaContable') &&
                                  <>
                                    <FormItem
                                      label="Cuenta contable"
                                      name="cuentaContablePagoId"
                                      margin
                                      required
                                      labelCol={{ span: 7 }}
                                      wrapperCol={{ span: 16 }}
                                    >
                                      <SelectItem placeholder="Cuenta contable del monto extra">
                                        {this.state.objetoCuentasContables}
                                      </SelectItem>
                                    </FormItem>
                                    <FormItem
                                      label="Monto extra"
                                      name="montoCuentaContable"
                                      tooltip={{ title: "Uno para todo el pago: sale del mismo banco junto con las facturas y se carga a la cuenta contable" }}
                                      margin
                                      required
                                      number
                                      type="number"
                                      labelCol={{ span: 7 }}
                                      wrapperCol={{ span: 16 }}
                                    >
                                      <InputNumberItem dinero placeholder="Monto extra a cuenta contable" />
                                    </FormItem>
                                  </>
                                }
                              </>
                            )
                          }
                        }}
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Row align="middle">
                        <Col span={12}>
                          <FormItem
                            label="Cheque"
                            name="cheque"
                            margin
                            labelCol={{ span: 12 }}
                            wrapperCol={{ span: 4 }}
                            valuePropName="checked"
                            initialValue={this.props.location.state.cheque}
                          >
                            <Checkbox onChange={this.onChangeCheque.bind(this)} />
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              const cheque = getFieldValue('cheque')
                              const bancoId = getFieldValue('bancoId')
                              if (cheque && bancoId) {
                                let consecutivoCheque = this.state.todasBancos.find(tBancos => tBancos._id.toString() === bancoId.toString()).consecutivoCheque
                                if (!consecutivoCheque) {
                                  consecutivoCheque = 1
                                }
                                return (
                                  <div style={{ textAlign: "center" }}>
                                    <Tag
                                      color="#00c1d61b"
                                      style={{
                                        fontSize: 13,
                                        border: '1px solid #00BFD6',
                                        padding: '4px 10px',
                                        borderRadius: 6,
                                        fontWeight: 600,
                                        color: '#026b77'
                               
                                      }}
                                    >
                                      N° Cheque: {consecutivoCheque}
                                    </Tag>
                                  </div>
                                )
                              }
                            }}
                          </FormItem>
                        </Col>
                      </Row>
                      <FormItem
                        name="referencia"
                        label="Referencia"
                        margin
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                        pattern
                      >
                        <InputItem placeholder="Referencia" />
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Row>

              <div style={{ marginTop: 24, marginBottom: 50 }}>
                <TabbedDynamicTable
                  tabs={(() => {
                    const tabs = [
                      {
                        key: "facturas",
                        label: "Facturas Pendientes",
                        listName: "facturas",
                        hideTableWhenEmpty: false,
                        columns: this.getFacturasColumns(),
                        renderHeader: () => this.renderTcGlobalHeader(),
                        renderRow: (rowProps) => this.renderFacturaRow(rowProps),
                      },
                    ];
                    if (this.state.creditosPendientes.length > 0) {
                      tabs.push({
                        key: "creditos",
                        label: "Créditos Pendientes",
                        listName: "creditos",
                        hideTableWhenEmpty: false,
                        columns: this.getCreditosColumns(),
                        renderRow: (rowProps) => this.renderCreditoRow(rowProps),
                      });
                    }
                    return tabs;
                  })()}
                />
              </div>

              <Row justify="end" style={{ marginTop: 32, marginBottom: 16 }}>
                <Col xs={24} sm={16} md={10} lg={10} xl={8}>
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      let facturas = getFieldValue("facturas");
                      let creditos = getFieldValue("creditos");
                      if (!facturas && !creditos) return null;
                      let total = 0;
                      (facturas || []).map((value) => {
                        let cantidadPagar = value.cantidadPagar
                          ? value.cantidadPagar
                          : 0;
                        total += cantidadPagar;
                        return null;
                      });
                      (creditos || []).map((value) => {
                        let cantidadPagar = value.cantidadPagar
                          ? value.cantidadPagar
                          : 0;
                        total += cantidadPagar;
                        return null;
                      });
                      //Monto extra a cuenta contable: sale del mismo banco junto con las facturas
                      const montoExtra = this.state.pagoConCuentaContableCxP && getFieldValue('pagoConCuentaContable')
                        ? (Number(getFieldValue('montoCuentaContable')) || 0)
                        : 0;
                      return (
                        <DynamicCardForm
                          span={24}
                          noMargin
                          style={{
                            padding: 0,
                            borderLeft: '4px solid #FF6A0D',
                          }}
                          bodyStyle={{
                            padding: '12px 16px',
                          }}
                        >
                          <table className="table" style={{ width: '100%', margin: 0 }}>
                            <tbody>
                              {this.state.pagoConCuentaContableCxP && getFieldValue('pagoConCuentaContable') &&
                                <>
                                  <tr>
                                    <th className="th-totales">Facturas:</th>
                                    <td className="td-totales-right">{dineroDisabledMask(total)}</td>
                                  </tr>
                                  <tr>
                                    <th className="th-totales">Extra a cuenta contable:</th>
                                    <td className="td-totales-right">{dineroDisabledMask(montoExtra)}</td>
                                  </tr>
                                </>
                              }
                              <tr>
                                <th className="th-totales" style={{ fontSize: 17, fontWeight: 700 }} >
                                  Total a pagar: 
                                </th>
                                <td
                                  className="td-totales-right"
                                  style={{ fontSize: 18, fontWeight: 700}}
                                >
                                  {dineroDisabledMask(round2Decimals(total + montoExtra))}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </DynamicCardForm>
                      );
                    }}
                  </FormItem>
                </Col>
              </Row>

             <div className="general-form-action-buttons-wrapper">
                <div className="general-form-action-buttons">
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    style
                    hotkey="alt+P"
                  >
                    Pagar  Cuenta
                  </ButtonItem>
                </div>
              </div>
            </Form>
          </Spin>
        </div>
        {this.renderModalAbonos()}
        {this.renderModalComision()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerFacturasProveedor);
